// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Banniere acheteur-MS V2 (fork autonome de SuiviHeader). */
/* Styles co-localises : ne pas mutualiser avec SuiviOperationMSV2.css (fork parallele). */

.opms-banner {
  position: relative;
  background-color: black;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  padding: 2rem 6rem;
  color: #fffdfc;
  margin-bottom: 2rem;
}

/* Retour en TEXTE (style login) au lieu du chevron : texte clair sur le fond sombre de la banniere. */
.opms-banner__back {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-bottom: 1.2rem;
  color: #fff;
  font-size: 1.4rem;
  font-weight: 500;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  transition: color 0.15s ease;
  width: auto;
}

.opms-banner__back:hover {
  color: #f97316;
}

/* Encart orange (a gauche) du suivi de commande MS acheteur : statut, n° panier, sensibilite, n° marche.
   Meme rendu que l'encart du SuiviHeader partage (classes propres au fork, CSS co-localise). */
.opms-banner__row {
  display: flex;
  align-items: center;
  gap: 2.4rem;
}
.opms-banner__col {
  flex: 1 1;
  min-width: 0;
}
.opms-banner__encart {
  flex-shrink: 0;
  align-self: center;
  min-width: 22rem;
  max-width: 28rem;
  background: #f97316;
  color: #fff;
  border-radius: 12px;
  padding: 1.4rem 1.6rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}
/* Statut = bandeau BLANC pleine largeur, CENTRE : nom en MAJUSCULES colore par statut (plus de libelle
   "Statut :"). Tient TOUJOURS sur une ligne (nowrap), taille reduite pour absorber les libelles longs. */
.opms-banner__encart-statut {
  background: #fff;
  border-radius: 8px;
  padding: 0.5rem 0.8rem;
  font-size: 1.3rem;
  font-weight: 700;
  line-height: 1.3;
  text-align: center;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* Lignes n° panier / n° marche : "label : valeur" sur UNE ligne (inline), alignees a gauche. */
.opms-banner__encart-ligne {
  font-size: 1.3rem;
  line-height: 1.4;
}
/* Variante bloc : label puis valeur sur DEUX lignes (n° de marche, valeur longue type "MS-25-..."). */
.opms-banner__encart-ligne--bloc {
  display: flex;
  flex-direction: column;
}
.opms-banner__encart-lbl {
  font-weight: 500;
  opacity: 0.9;
}
.opms-banner__encart-val {
  font-weight: 700;
  word-break: break-word;
}
/* Chrono en bas de l'encart orange : libelle "Temps restant :" au-dessus, valeur en BLANC sans
   encadrement, centre. On neutralise le fond blanc / la bordure / la couleur d'urgence. */
.opms-banner__encart-chrono {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.15rem;
}
.opms-banner__encart-chrono-lbl {
  font-size: 1.1rem;
  font-weight: 500;
  opacity: 0.9;
}
.opms-banner__encart-chrono .countdown,
.opms-banner__encart-chrono .countdown.urgent,
.opms-banner__encart-chrono .countdown.warning,
.opms-banner__encart-chrono .countdown.normal,
.opms-banner__encart-chrono .countdown.expired {
  background: transparent;
  border: none;
  padding: 0;
  color: #fff;
  font-size: 1.6rem;
  font-weight: 700;
}
/* Sensibilite deplacee dans le bloc de droite : une ligne, blanche, sur le fond sombre. */
.opms-banner__sensibilite {
  color: #fff;
  font-size: 1.5rem;
  font-weight: 500;
  margin: 0.2rem 0 1rem;
}

.opms-banner h1,
.opms-banner h2,
.opms-banner__subtitle {
  color: white;
}

.opms-banner h1 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: block;
}

.opms-banner__subtitle {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: 1.6rem;
  font-weight: 500;
}

/* Pilule blanche du statut (reprise de la regle globale .status-header de la banniere
   canonique : fond blanc, padding, coins arrondis, icone + libelle + chrono alignes).
   Le fork namespace ne captait plus la regle globale -> restauree localement. */
.opms-banner__status-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  background-color: white;
  width: fit-content;
  padding: 1rem;
  border-radius: 50px;
}

.opms-banner__status-header span {
  font-size: 1.6rem;
  font-weight: 700;
}

/* Le chrono (CompteARebourd) porte ses propres styles globaux .countdown.
   Conteneur inline a cote du badge, sans regle propre comme l'oracle. */
`, "",{"version":3,"sources":["webpack://./src/pages/SuiviOperationMSV2/components/OperationHeaderBanner.css"],"names":[],"mappings":"AAAA,4DAA4D;AAC5D,0FAA0F;;AAE1F;EACE,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA,sGAAsG;AACtG;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;+FAC+F;AAC/F;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,SAAO;EACP,YAAY;AACd;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,yCAAyC;AAC3C;AACA;yGACyG;AACzG;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,+FAA+F;AAC/F;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA,sGAAsG;AACtG;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;AACA;0FAC0F;AAC1F;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;AACA;;;;;EAKE,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;AACA,0FAA0F;AAC1F;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;gFAEgF;AAChF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;wEACwE","sourcesContent":["/* Banniere acheteur-MS V2 (fork autonome de SuiviHeader). */\n/* Styles co-localises : ne pas mutualiser avec SuiviOperationMSV2.css (fork parallele). */\n\n.opms-banner {\n  position: relative;\n  background-color: black;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  padding: 2rem 6rem;\n  color: #fffdfc;\n  margin-bottom: 2rem;\n}\n\n/* Retour en TEXTE (style login) au lieu du chevron : texte clair sur le fond sombre de la banniere. */\n.opms-banner__back {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  margin-bottom: 1.2rem;\n  color: #fff;\n  font-size: 1.4rem;\n  font-weight: 500;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  transition: color 0.15s ease;\n  width: auto;\n}\n\n.opms-banner__back:hover {\n  color: #f97316;\n}\n\n/* Encart orange (a gauche) du suivi de commande MS acheteur : statut, n° panier, sensibilite, n° marche.\n   Meme rendu que l'encart du SuiviHeader partage (classes propres au fork, CSS co-localise). */\n.opms-banner__row {\n  display: flex;\n  align-items: center;\n  gap: 2.4rem;\n}\n.opms-banner__col {\n  flex: 1;\n  min-width: 0;\n}\n.opms-banner__encart {\n  flex-shrink: 0;\n  align-self: center;\n  min-width: 22rem;\n  max-width: 28rem;\n  background: #f97316;\n  color: #fff;\n  border-radius: 12px;\n  padding: 1.4rem 1.6rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);\n}\n/* Statut = bandeau BLANC pleine largeur, CENTRE : nom en MAJUSCULES colore par statut (plus de libelle\n   \"Statut :\"). Tient TOUJOURS sur une ligne (nowrap), taille reduite pour absorber les libelles longs. */\n.opms-banner__encart-statut {\n  background: #fff;\n  border-radius: 8px;\n  padding: 0.5rem 0.8rem;\n  font-size: 1.3rem;\n  font-weight: 700;\n  line-height: 1.3;\n  text-align: center;\n  text-transform: uppercase;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n/* Lignes n° panier / n° marche : \"label : valeur\" sur UNE ligne (inline), alignees a gauche. */\n.opms-banner__encart-ligne {\n  font-size: 1.3rem;\n  line-height: 1.4;\n}\n/* Variante bloc : label puis valeur sur DEUX lignes (n° de marche, valeur longue type \"MS-25-...\"). */\n.opms-banner__encart-ligne--bloc {\n  display: flex;\n  flex-direction: column;\n}\n.opms-banner__encart-lbl {\n  font-weight: 500;\n  opacity: 0.9;\n}\n.opms-banner__encart-val {\n  font-weight: 700;\n  word-break: break-word;\n}\n/* Chrono en bas de l'encart orange : libelle \"Temps restant :\" au-dessus, valeur en BLANC sans\n   encadrement, centre. On neutralise le fond blanc / la bordure / la couleur d'urgence. */\n.opms-banner__encart-chrono {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.15rem;\n}\n.opms-banner__encart-chrono-lbl {\n  font-size: 1.1rem;\n  font-weight: 500;\n  opacity: 0.9;\n}\n.opms-banner__encart-chrono .countdown,\n.opms-banner__encart-chrono .countdown.urgent,\n.opms-banner__encart-chrono .countdown.warning,\n.opms-banner__encart-chrono .countdown.normal,\n.opms-banner__encart-chrono .countdown.expired {\n  background: transparent;\n  border: none;\n  padding: 0;\n  color: #fff;\n  font-size: 1.6rem;\n  font-weight: 700;\n}\n/* Sensibilite deplacee dans le bloc de droite : une ligne, blanche, sur le fond sombre. */\n.opms-banner__sensibilite {\n  color: #fff;\n  font-size: 1.5rem;\n  font-weight: 500;\n  margin: 0.2rem 0 1rem;\n}\n\n.opms-banner h1,\n.opms-banner h2,\n.opms-banner__subtitle {\n  color: white;\n}\n\n.opms-banner h1 {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  display: block;\n}\n\n.opms-banner__subtitle {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  font-size: 1.6rem;\n  font-weight: 500;\n}\n\n/* Pilule blanche du statut (reprise de la regle globale .status-header de la banniere\n   canonique : fond blanc, padding, coins arrondis, icone + libelle + chrono alignes).\n   Le fork namespace ne captait plus la regle globale -> restauree localement. */\n.opms-banner__status-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  background-color: white;\n  width: fit-content;\n  padding: 1rem;\n  border-radius: 50px;\n}\n\n.opms-banner__status-header span {\n  font-size: 1.6rem;\n  font-weight: 700;\n}\n\n/* Le chrono (CompteARebourd) porte ses propres styles globaux .countdown.\n   Conteneur inline a cote du badge, sans regle propre comme l'oracle. */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
